import React, { useState, useEffect } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import classnames from 'classnames';

const Tooltip = props => {

  const {html} = props;
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const tooltip = doc.querySelector('.tooltip');


  if (tooltip != null){
    const tooltip_title = tooltip.textContent;
    const tooltip_text = tooltip.dataset.tooltip_text;
    const tooltip_theme = tooltip.dataset.tooltip_theme;

    return (
      <Tippy content={tooltip_text} >
        <div className="tooltip" data-tooltip_text={tooltip_text} data-tooltip_theme={tooltip_theme}>{tooltip_title}</div>
      </Tippy>
    )
  } else {
    return "";
  }




}

export default Tooltip;
